import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getCenterPartners } from "../../../store/actions/centerActions/b2bPartnerAction";
import AddPartnerModal from "./AddPartnerModal";

/*
  The consultant partners this center added (owner, 2026-10-10).

  A center registers a consultant itself, and every student that consultant
  brings is filed under this center - so they show up in this center's own
  student list, marked with the consultant's name.

  The council still approves: a partner added here cannot sign in until it
  does, and the council is also what sets the commission. So nothing on this
  screen suspends a partner or touches its money.
*/
const CenterPartnerList = () => {
  const dispatch = useDispatch();
  const [list, setList] = useState(null);
  const [adding, setAdding] = useState(false);
  const [done, setDone] = useState("");

  const load = async () => {
    setList(null);
    const rows = await dispatch(getCenterPartners());
    setList(Array.isArray(rows) ? rows : []);
  };

  useEffect(() => {
    load();
  }, []);

  /* Bootstrap 4 class names, like the rest of this portal: the stylesheet here
     is 4.6, so react-bootstrap's own `bg=` prop would render a class the CSS
     does not have and the badge would come out unstyled. */
  const statusCell = (s) => {
    if (s === "active") return <span className="badge badge-success">Active</span>;
    if (s === "rejected") return <span className="badge badge-danger">Rejected</span>;
    if (s === "suspended") return <span className="badge badge-secondary">Suspended</span>;
    return <span className="badge badge-warning">Waiting for approval</span>;
  };

  return (
    <div className="Title-box">
      <div className="row align-items-center">
        <div className="col-md-6">
          <div className="BigTitle">Consultant Partners</div>
        </div>
        <div className="col-md-6 text-right">
          <Button
            variant="primary"
            onClick={() => {
              setDone("");
              setAdding(true);
            }}
          >
            Add Consultant Partner
          </Button>
        </div>
      </div>

      {done ? (
        <div className="alert alert-success mt-3 mb-0">{done}</div>
      ) : null}

      <div className="mid-content-box mt-3">
        {list === null ? (
          <div className="text-center mt-4">
            <Spinner animation="border" role="status" size="lg">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : list.length === 0 ? (
          <div className="text-center text-muted py-4">
            No consultant partner added yet. Add one and the students it brings
            will come under this center.
          </div>
        ) : (
          <Table responsive>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Name</th>
                <th>Organization</th>
                <th>Partner Code</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>City</th>
                <th>Students</th>
                <th>Added On</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {list.map((r, i) => (
                <tr key={r.id}>
                  <td>{i + 1}</td>
                  <td>{r.name}</td>
                  <td>{r.firm_name || "-"}</td>
                  {/* the code is given by the council at approval, so it is
                      empty until then */}
                  <td>{r.partner_code || "-"}</td>
                  <td>{r.email}</td>
                  <td>{r.mobile}</td>
                  <td>{r.city || "-"}</td>
                  <td>{r.students}</td>
                  <td>
                    {r.created_at
                      ? moment(r.created_at).format("DD MMM YYYY")
                      : "-"}
                  </td>
                  <td>{statusCell(r.status)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>

      <AddPartnerModal
        show={adding}
        onClose={() => setAdding(false)}
        onAdded={(msg) => {
          setAdding(false);
          setDone(msg);
          load();
        }}
      />
    </div>
  );
};

export default CenterPartnerList;
